export default class TemplateAccount {
  constructor({ el }) {
    this.el = el;

    const deleteAddressEls = this.el.querySelectorAll('.delete-address');
    const editAddressEls = this.el.querySelectorAll('.edit-address');
    const addNewAddressEl = this.el.querySelector('.add-new-address');
    const toggleForgetfulnessEl = this.el.querySelector('.toggle-forgetfulness');
    const addressCountryEl = this.el.querySelector('.address-country');

    if (deleteAddressEls.length) {
      deleteAddressEls.forEach(deleteAddressEl => deleteAddressEl.addEventListener('click', event => this.deleteAddress(event)));
    }

    if (editAddressEls.length) {
      editAddressEls.forEach(editAddressEl => editAddressEl.addEventListener('click', event => this.editAddress(event)));
    }

    if (addNewAddressEl) {
      addNewAddressEl.addEventListener('click', () => this.addNewAddress());
    }

    if (toggleForgetfulnessEl) {
      toggleForgetfulnessEl.addEventListener('click', () => this.recoverPassword());
    }

    if (addressCountryEl) {
      addressCountryEl.addEventListener('change', () => this.updateProvinceSelectText());
    }

    if (this.el.classList.contains('template-addresses')) { this.prepareAddresses(); }
    if (this.el.classList.contains('template-login')) { this.checkForReset(); }
    if (window.location.hash === '#recover') { return this.recoverPassword(); }
  }

  recoverPassword() {
    this.el.querySelector('.recover-password').classList.toggle('visible');
    this.el.querySelector('.customer-login').classList.toggle('visible');
  }

  checkForReset() {
    if ('sucessfulReset' in this.el.querySelector('.reset-check').dataset) {
      this.el.querySelector('.successful-reset').classList.add('visible');
    }
  }

  prepareAddresses() {
    new Shopify.CountryProvinceSelector('address-country', 'address-province', {
      hideElement: 'address-province-container',
    });

    const addresses = this.el.querySelectorAll('.customer-address');

    addresses.forEach(address => {
      const addressID = address.dataset.addressId;

      new Shopify.CountryProvinceSelector(`address-country-${addressID}`, `address-province-${addressID}`, {
        hideElement: `address-province-container-${addressID}`,
      });
    });
  }

  deleteAddress(e) {
    const addressID = e.target.closest('[data-address-id]').dataset.addressId;

    Shopify.CustomerAddress.destroy(addressID);
  }

  editAddress(e) {
    const addressID = e.target.closest('[data-address-id]').dataset.addressId;

    this.el.querySelector('.customer-address').classList.remove('editing');
    this.el.querySelector('.customer-address').querySelector('.edit-address').classList.remove('disabled');

    this.el.querySelector(`.customer-address[data-address-id='${addressID}']`).classList.add('editing');
    this.el.querySelector(`.customer-address[data-address-id='${addressID}']`).querySelector('.edit-address').classList.add('disabled');

    this.el.querySelector('.customer-address-edit-form, .customer-new-address').classList.add('hidden');

    this.el.querySelector(`.customer-address-edit-form[data-address-id='${addressID}']`).classList.remove('hidden');
  }

  addNewAddress() {
    this.el.querySelector('.customer-address').classList.remove('editing');
    this.el.querySelector('.customer-address').querySelector('.edit-address').classList.remove('disabled');


    this.el.querySelector('.customer-address-edit-form').classList.add('hidden');
    this.el.querySelector('.customer-new-address').classList.remove('hidden');
  }

  updateProvinceSelectText() {
    this.el.querySelector('.address-province').previousElementSibling.innerText = `-- ${window.Theme.pleaseSelectText} --`;
  }
}
